// Items only belong to the currently-open sheet; guard against stale data on sheet switch.
export const selectRecentChanges = (sheetId) => (store) =>
  store.recentChanges.sheetId === sheetId ? store.recentChanges.items : [];

export const selectRecentChangesLoading = (store) => store.recentChanges.loading;
